<div class="space-y-sm" *transloco="let t">
  @if (regions() && regions()?.length) {
    <div>
      @for (region of regions(); track region.slug) {
        <div class="space-y-lg border-b border-grey-300 pb-2xl last:border-none" [title]="region.regionName">
          <div class="flex items-center justify-between" [class.pt-2xl]="!$first">
            <h3 class="text-center text-xl">
              <a [routerLink]="getRegionPageLink(region.slug)" class="flex gap-sm">
                {{ t('regionsDirectoryPage.regionOverview.title', {regionName: region.regionName}) }}
              </a>
            </h3>
            <a [routerLink]="getRegionPageLink(region.slug)" class="btn flex gap-sm btn-ghost">
              {{ t('proDirectoryPage.industry.moreButton') }}
              <fa-icon [icon]="chevronRight"></fa-icon>
            </a>
          </div>
          <div class="grid grid-cols-1 gap-x-2xl gap-y-md pr-lg md:grid-cols-2 lg:grid-cols-3">
            @for (industry of industries(); track industry.slug) {
              @if (!region.excludedIndustryIds.includes(industry.id)) {
                <cft-list-element
                  truncateLabel
                  [link]="getIndustryRegionPageLink(region.slug, industry.slug)"
                  [label]="
                    t('regionsDirectoryPage.directory.regionLinkText', {
                      regionName: region.regionName,
                      industryName: industry.label,
                    })
                  "
                />
              }
            }
          </div>
        </div>
      }
    </div>
    @if (pagination(); as p) {
      <div class="flex w-full items-center justify-center">
        <cft-pagination
          [showPageNumbers]="true"
          [pageOffset]="p.offset"
          [pageSize]="p.size"
          [total]="p.total"
          (nextClick)="nextPage()"
          (previousClick)="previousPage()"
          (pageClick)="goToPage($event)"
        ></cft-pagination>
      </div>
    }
  } @else {
    <bgo-industries-and-regions-skeleton />
  }
</div>
